import { Component, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '@env/environment';
import { IonApp, IonRouterOutlet, Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@core/services';

@Component({
  imports: [IonApp, IonRouterOutlet],
  selector: 'app-root',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  isDev = !environment.production;

  constructor(
    private platform: Platform,
    private translate: TranslateService,
    private storageService: StorageService,
  ) {
    this.initializeTranslate();
    this.initializeApp();
  }

  loadLanguage() {
    this.storageService.get('language').then((language) => {
      if (language) {
        this.setLanguage(language as string);
      } else {
        const bestLanguage = this.getBestLanguage();
        this.setLanguage(bestLanguage);
      }
    });
  }

  async setLanguage(language: string) {
    this.translate.use(language);
    await this.storageService.set('language', language);
  }

  private getBestLanguage(): string {
    const browserLang = navigator.language.split('-')[0].toLowerCase();
    const allowedLanguages = ['es', 'en'];
    return allowedLanguages.includes(browserLang) ? browserLang : 'en';
  }

  initializeTranslate() {
    this.loadLanguage();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      SplashScreen.hide();
    });
  }
}
